import React from 'react';
import './Terms.css'; // Import the Terms.css file for styling

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <h1 className="terms-heading">Terms of Service</h1>

      <h2 className="terms-subheading">1. Introduction</h2>
      <p className="terms-text">
        Welcome to our website. By accessing and using this website, you accept and agree to be bound by the terms and conditions set forth in these Terms of Service. If you do not agree to these terms, you should not use the website.
      </p>

      <h2 className="terms-subheading">2. Intellectual Property Rights</h2>
      <p className="terms-text">
        All materials, content, and trademarks on this website are the property of our company and protected by copyright and other intellectual property laws. You may not use, reproduce, modify, or distribute any content from this website without our prior written consent.
      </p>

      <h2 className="terms-subheading">3. User Accounts</h2>
      <p className="terms-text">
        In order to access certain features of this website, you may need to create a user account. You are responsible for maintaining the confidentiality of your account and password and for all activities that occur under your account.
      </p>

      <h2 className="terms-subheading">4. Limitation of Liability</h2>
      <p className="terms-text">
        Our company will not be liable for any direct, indirect, incidental, consequential, or special damages arising out of or in connection with the use or inability to use this website, even if we have been advised of the possibility of such damages.
      </p>

      <h2 className="terms-subheading">5. Governing Law</h2>
      <p className="terms-text">
        These Terms of Service shall be governed by and construed in accordance with the laws of USA, without regard to its conflict of laws principles.
      </p>

      <h2 className="terms-subheading">6. Changes to Terms of Service</h2>
      <p className="terms-text">
        We reserve the right to modify or replace these Terms of Service at any time. By continuing to use the website after any changes, you agree to be bound by the revised terms.
      </p>

      <h2 className="terms-subheading">7. Contact Us</h2>
      <p className="terms-text">
        If you have any questions or concerns about these Terms of Service, please contact us at info@wertdigital.online.
      </p>
    </div>
  );
};

export default TermsOfService;
